(function ($) {
  var panelTransitionDuration = 200;

  function openMobileMenu($menu) {
    var $panel = $menu.find('.main-menu__mobile-panel');

    clearTimeout($menu.data('mainMenuCloseTimer'));
    $menu.find('.main-menu__mobile-trigger').attr('aria-expanded', 'true');
    $panel.prop('hidden', false);

    window.requestAnimationFrame(function () {
      $menu.addClass('main-menu--mobile-open');
    });
  }

  function closeMobileMenu($menu) {
    clearTimeout($menu.data('mainMenuCloseTimer'));
    $menu.removeClass('main-menu--mobile-open');
    $menu.find('.main-menu__mobile-trigger').attr('aria-expanded', 'false');

    $menu.data('mainMenuCloseTimer', setTimeout(function () {
      $menu.find('.main-menu__mobile-panel').prop('hidden', true);
    }, panelTransitionDuration));
  }

  function initMenu($scope) {
    $scope.find('.main-menu').each(function () {
      var $menu = $(this);

      if ($menu.data('mainMenuInitialized')) {
        return;
      }

      $menu.data('mainMenuInitialized', true);

      $menu.on('click', '.main-menu__mobile-trigger', function () {
        if ($menu.hasClass('main-menu--mobile-open')) {
          closeMobileMenu($menu);
          return;
        }

        openMobileMenu($menu);
      });

      $menu.on('click', '.main-menu__mobile-toggle-item', function () {
        var $toggle = $(this);
        var isOpen = $toggle.attr('aria-expanded') === 'true';

        $toggle.attr('aria-expanded', String(!isOpen));
        $toggle.closest('.main-menu__mobile-item').toggleClass('main-menu__mobile-item--open', !isOpen);
        $toggle.next('.main-menu__mobile-submenu').prop('hidden', isOpen);
      });
    });
  }

  $(document).on('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    $('.main-menu--mobile-open').each(function () {
      var $menu = $(this);
      closeMobileMenu($menu);
      $menu.find('.main-menu__mobile-trigger').trigger('focus');
    });
  });

  $(function () {
    initMenu($(document));
  });

  $(window).on('elementor/frontend/init', function () {
    if (!window.elementorFrontend || !window.elementorFrontend.hooks) {
      return;
    }

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/custom-main-menu.default',
      initMenu
    );
  });
})(jQuery);
